/**
 * 根据当前页面路径找到最匹配的下载链接配置（cn码不同）
 *
 * @param pathname - 当前页面的路径，例如 '/blog/1/title'
 * @param config - 页面下载链接配置对象，key 为路径，value 为下载链接数组，数组第一项为非37地区的链接，第二项为37地区的下载链接
 * @returns 返回最匹配的配置 key，如果没有匹配则返回 null
 *
 * @example
 * const pathname = '/blog/1/title';
 * const matchedKey = findBestMatch(pathname, config); // 返回 '/blog/'
 */

type DownloadLinksConfig = Record<string, [string, string]>

export function findBestMatch(pathname: string, config: DownloadLinksConfig): string {
  let bestMatch = ''
  let bestMatchLength = 0

  if (pathname === '/') return '/'

  Object.keys(config).forEach(key => {
    if (key === '/') return

    if (pathname === key) {
      bestMatch = key
      return
    }

    if (key.endsWith('/') && pathname.startsWith(key)) {
      const matchLength = key.split('/').length
      if (matchLength > bestMatchLength) {
        bestMatchLength = matchLength
        bestMatch = key
      }
    }
  })

  return bestMatch
}
